import React, { useState, useContext } from 'react';
import { Dimmer, Loader, Button, Dropdown, Icon, Input, Select, Divider, Form } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DailyActivityForm = ({ activity, saveHandler, cancelHandler }) => {
    const { text, startTime } = activity;
    const [textInput, setTextInput] = useState(text);
    const [dateStringInput, setDateStringInput] = useState(startTime);
    const [loading, setLoading] = useState(false);


    const saveItem = async () => {
        setLoading(true);
        await saveHandler({
            ...activity,
            text: textInput,
            //Make it number 
            startTime: Number.isInteger(dateStringInput) ? dateStringInput :  Date.parse(dateStringInput),
        });
        setTextInput('');
        setLoading(false);
    };

    return (
        <div className="">
            <div className="create-menu">
                <Dimmer active={loading} inverted>
                    <Loader active={loading} />
                </Dimmer>
                <Form>
                    <div className="fields">
                        <DatePicker
                            selected={dateStringInput}
                            onChange={(date) => setDateStringInput(date)}
                            placeholderText="Date"
                            showTimeSelect
                            customInput={<Input placeholder="Date" />}
                        />
                        <Input
                            placeholder="Activity title"
                            value={textInput}
                            onChange={(e) => setTextInput(e.target.value)}
                        />
                     
                        <Button
                            primary={textInput ? true : false}
                            disabled={textInput ? false : true}
                            onClick={saveItem}
                        >
                            Save
                        </Button>
                        {cancelHandler && <Button onClick={cancelHandler}>Cancel</Button>}
                    </div>
                </Form>
            </div>
        </div>
    );
};
export default DailyActivityForm;
